import { Trans } from '@lingui/react'

import { useSubmitBankConnectionIntroMutation } from '@twisto/api-graphql'
import {
  Headline,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'
import {
  BulletedList,
  BulletedListItem,
} from '@twisto/components/molecules/list'
import { FlowFormSubmitButton } from '@twisto/flow-views/components'
import { BankIcon, ChartOutlineIcon, SecurityIcon } from '@twisto/icons'

import { useFlow } from '../../flow/flow.context'

import * as styles from './bank-connection-intro-step.styles'

export const BankConnectionIntroStep = () => {
  const { sessionId } = useFlow<'BankConnectionIntroStep'>()
  const [submitBankConnectionIntro] = useSubmitBankConnectionIntroMutation({
    variables: {
      auth: {
        sessionId,
      },
    },
  })

  return (
    <>
      <Headline align="start">
        <HeadlineTitle>
          <Trans id="flow.bankConnectionIntro.title" />
        </HeadlineTitle>
        <HeadlineSubtitle>
          <Trans id="flow.bankConnectionIntro.subtitle" />
        </HeadlineSubtitle>
      </Headline>

      <BulletedList css={styles.list}>
        <BulletedListItem
          customIcon={
            <ChartOutlineIcon color="primary" height="100%" width="100%" />
          }
        >
          <Trans id="flow.bankConnectionIntro.listItem.one" />
        </BulletedListItem>
        <BulletedListItem
          customIcon={<BankIcon color="primary" height="100%" width="100%" />}
        >
          <Trans id="flow.bankConnectionIntro.listItem.two" />
        </BulletedListItem>
        <BulletedListItem
          customIcon={
            <SecurityIcon color="primary" height="100%" width="100%" />
          }
        >
          <Trans id="flow.bankConnectionIntro.listItem.three" />
        </BulletedListItem>
      </BulletedList>

      <FlowFormSubmitButton onSubmit={submitBankConnectionIntro} />
    </>
  )
}
